// extracted by mini-css-extract-plugin
export var container = "_2m-1";
export var editor = "_2m-2";
export var resizable = "_2m-3";
export var wrapper = "_2m-0";